import React from 'react';

import LinkButton from 'components/uiLibrary/LinkButton';
import SpriteIcon from 'components/uiLibrary/SpriteIcon';
import Typography from 'components/uiLibrary/Typography';

import { COMPONENTS } from 'components/Globals/Analytics/constants';

import useDeviceTypeLayouts from 'utils/hooks/useDeviceTypeLayouts';

import { useTranslation } from 'src/i18n';

import classes from './Banner.module.scss';

const Banner = ({ title, items, onClick, trackingData }) => {
  const { t } = useTranslation('NS_APP_GLOBALS');
  const { isDesktop } = useDeviceTypeLayouts();

  return (
    <LinkButton
      variant="text"
      styles={{ root: classes.banner }}
      onClick={onClick}
      disableUnderline
      trackingData={{
        ...trackingData,
        component: COMPONENTS.BANNER,
      }}
    >
      <Typography className={classes.title} size={isDesktop ? 14 : 12} weight="bold">
        {t(title)}
      </Typography>
      {items.map(item => (
        <Typography key={item} size={isDesktop ? 12 : 10} color="quaternary" className={classes.item}>
          {t(item)}
        </Typography>
      ))}
      <SpriteIcon icon="chevron_right" size="13" className={classes.arrow} />
    </LinkButton>
  );
};

export default Banner;
